export default __webpack_public_path__ + "static/_cover-181c784246bb439108ac1c4384d3d4e2.png";